
import Utils from '@/ecm/common/Utils'
import SearchConstValues from '@/ecm/variables/SearchConstValues'
import FieldType from '@/ecm/variables/FieldType'
import store from '@/store'
export default class ConditionItem {
    constructor(conditionStr) {
        this.uuid = Utils.object.getUUID()
        this.fieldCode = ''
        this.fieldTitle = ''
        this.fieldType = ''
        this.searchOperatorCode = ''
        this.searchOperatorTitle = ''
        this.fieldValue = ''
        this.fieldDisplayValue = ''
        this.isLogicalOperator = false
        this.color = ''
        this.useMyself = false
        this.useToday = false
        this.isParameterizable = false
        this.multiValue = false
        this.daysBeforeAfterToday = 0
        this.beforeAfter = 'B'
        this.keyword = ""
        this.valueType = "Static"

        if (conditionStr) {
            var logicalOperators = [
                { value: '(', color: 'blue-grey' },
                { value: 'OR', color: 'blue' },
                { value: 'AND', color: 'teal' },
                { value: ')', color: 'blue-grey' },
            ]
            if (
                logicalOperators.some((o) => o.value == conditionStr)
            ) {
                // OPERATOR
                var operator = logicalOperators.find(
                    (o) => o.value == conditionStr
                )
                this.fieldValue = operator.value
                this.isLogicalOperator = true
                this.color = operator.color
            } else {
                // CONDITION
                var props = conditionStr.split('|')
                this.fieldCode = props[0]
                this.searchOperatorCode = props[1]
                this.fieldValue = props[2]
                this.fieldType = FieldType[props[3]]
                this.color = 'blue darken-4'
                if (this.fieldValue == SearchConstValues.Myself) {
                    this.useMyself = true
                }
                else if (this.fieldValue == SearchConstValues.Today) {
                    this.useToday = true
                }
                else if (this.fieldValue.includes(SearchConstValues.DaysBeforeToday)) {
                    this.useToday = true
                    this.beforeAfter = 'B'
                    this.daysBeforeAfterToday = parseInt(
                        this.fieldValue.replace(SearchConstValues.DaysBeforeToday, '').trim()
                    )
                }
                else if (this.fieldValue.includes(SearchConstValues.DaysAfterToday)) {
                    this.useToday = true
                    this.beforeAfter = 'A'
                    this.daysBeforeAfterToday = parseInt(
                        this.fieldValue.replace(SearchConstValues.DaysAfterToday, '').trim()
                    )
                }
            }
        }
    }

    conditionStr() {
        if (this.isLogicalOperator) {
            return this.fieldValue
        } else {
            return `${this.fieldCode}|${this.searchOperatorCode}|${this.fieldValue}|${FieldType[this.fieldType]}`
        }
    }

    displayText() {
        if (this.isLogicalOperator) {
            return this.fieldValue
        } else {
            return `${this.fieldTitle} ${this.searchOperatorTitle} ${this.fieldDisplayValue}`
        }
    }
}
